 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0,
 		7: 0,
 		75: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0,
 		7: 0,
 		75: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~route-MapView~route-account~route-adminAdvertisements~route-adminAnnouncements~route-adminCa~054a1cde","1":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~b21f9f2b","2":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCa~da16283f","3":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","4":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-zoo","5":"route-account~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","7":"vendors~route-album~route-gift~route-partnerDonation","8":"vendors~route-habitat~route-highlights~route-home","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-partnerDonation","45":"route-passwordReset","46":"route-profile","47":"route-redeem","48":"route-reports","49":"route-schedule","50":"route-signup","51":"route-socialLogin","52":"route-softReload","53":"route-start","54":"route-talkSchedule","55":"route-welcome","56":"route-zoo"}[chunkId]||chunkId) + ".chunk." + {"0":"eb6be","1":"08f09","2":"87bd1","3":"81a6d","4":"0d604","5":"59b16","6":"3ca10","7":"390d1","8":"8d461","9":"2bc63","10":"83904","11":"55c4e","12":"11563","16":"906f2","17":"19a5f","18":"6dfae","19":"847af","20":"b8af6","21":"e4ae1","22":"e64a6","23":"22241","24":"aad60","25":"b785b","26":"25cf5","27":"449cf","28":"a8d6b","29":"31e35","30":"b9535","31":"e1378","32":"dadfd","33":"a13ba","34":"44d87","35":"6f5e2","36":"e9b61","37":"be929","38":"0e5fc","39":"3b16b","40":"887f5","41":"5ad52","42":"8d2ff","43":"3d605","44":"1e076","45":"22547","46":"2f8f6","47":"bce40","48":"98cb1","49":"b827a","50":"5ee88","51":"11330","52":"f9fb2","53":"5d55e","54":"3b689","55":"a6456","56":"558f8","57":"45ea9","58":"8ae7f","59":"9951e","60":"45f45","61":"029d9","62":"7b34a","63":"24a50","64":"fc838","65":"d510d","66":"64fc0","67":"55c78","68":"1b553","69":"cc74c","70":"1df9f","71":"c061b","72":"83850","73":"55eda","74":"ea855","76":"ff6b0","77":"de09c","78":"15ecb","79":"0441f","80":"b5bb8","81":"2a7fc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"9":1,"11":1,"12":1,"16":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"27":1,"29":1,"30":1,"31":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"40":1,"41":1,"42":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"54":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"68":1,"69":1,"70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~route-MapView~route-account~route-adminAdvertisements~route-adminAnnouncements~route-adminCa~054a1cde","1":"vendors~route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route~b21f9f2b","2":"route-MapView~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCa~da16283f","3":"vendors~route-adminAdvertisements~route-adminAnnouncements~route-adminCameraInfo~route-adminCameraSe~ffd0fef2","4":"vendors~route-MapView~route-album~route-habitat~route-highlights~route-home~route-myAlbum~route-zoo","5":"route-account~route-feed~route-habitats~route-help~route-notifications~route-talkSchedule","7":"vendors~route-album~route-gift~route-partnerDonation","8":"vendors~route-habitat~route-highlights~route-home","16":"route-MapView","17":"route-TermsAndPrivacy","18":"route-account","19":"route-adminAdvertisements","20":"route-adminAnnouncements","21":"route-adminCameraInfo","22":"route-adminCameraSettings","23":"route-adminConfigurations","24":"route-adminHabitats","25":"route-adminOnlineUsersInfo","26":"route-adminPartners","27":"route-adminPlaylists","28":"route-adminTestNewModelsForAiKeeper","29":"route-adminUsers","30":"route-album","31":"route-emailVerify","32":"route-feed","33":"route-gift","34":"route-habitat","35":"route-habitats","36":"route-help","37":"route-highlights","38":"route-home","39":"route-importBundleUsers","40":"route-login","41":"route-myAlbum","42":"route-notFound","43":"route-notifications","44":"route-partnerDonation","45":"route-passwordReset","46":"route-profile","47":"route-redeem","48":"route-reports","49":"route-schedule","50":"route-signup","51":"route-socialLogin","52":"route-softReload","53":"route-start","54":"route-talkSchedule","55":"route-welcome","56":"route-zoo"}[chunkId]||chunkId) + ".chunk." + {"0":"31d6c","1":"31d6c","2":"31a72","3":"31d6c","4":"31d6c","5":"31d6c","6":"31d6c","7":"31d6c","8":"31d6c","9":"18e4e","10":"31d6c","11":"37e29","12":"4cd1c","16":"205a3","17":"31d6c","18":"5a6cd","19":"197d1","20":"197d1","21":"197d1","22":"54271","23":"197d1","24":"abe1c","25":"31d6c","26":"5acf9","27":"197d1","28":"31d6c","29":"06749","30":"639f8","31":"7990d","32":"31d6c","33":"cca43","34":"4be58","35":"60ed8","36":"f1e80","37":"86820","38":"89b52","39":"31d6c","40":"1b2e4","41":"96c82","42":"5318a","43":"31d6c","44":"73c7e","45":"5255f","46":"8c877","47":"a3247","48":"576ae","49":"ba79a","50":"3a45d","51":"31d6c","52":"31d6c","53":"31d6c","54":"ba6f8","55":"31d6c","56":"96135","57":"df059","58":"fa475","59":"3f8cb","60":"429d0","61":"c51fe","62":"1fa4d","63":"b2ca4","64":"f3859","65":"31d6c","66":"31d6c","67":"31d6c","68":"65381","69":"91a66","70":"756f3","71":"31d6c","72":"31d6c","73":"31d6c","74":"31d6c","76":"31d6c","77":"31d6c","78":"31d6c","79":"31d6c","80":"31d6c","81":"31d6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "brot");
